import React , {useState } from "react";
import { useSelector } from 'react-redux'

import 'moment/locale/es';
import { Button, Card, CardHeader, CardBody, Table, Form, Row, Col,FormGroup, Input} from "reactstrap";
import AsyncSelect from 'react-select/async';
import { Link } from 'react-router-dom';
import Select from "react-select";


var courseApi = require ('../api');

var Utils = require ('Utils') ;
var Const = require ('Const');
var Icons = require ('Icons');


export const  CourseSetupSubject = ( { subj , scheduleClasss, unScheduleClass, enrollTeacher, unEnrollTeacher  } ) => {

  const [inputValue, setValue] = useState('');
  const [subject, setSubject] = useState( subj ) ;
  const [selectedValue, setSelectedValue] = useState(null);
  const [ formData, setFormData] = useState({});
 
  const { course, token } = useSelector(state => ({
    currentCalendarID: state.school.currentCalendarID,
    token: state.auth.session.jwt_token, 
    course: state.courses.course,
    // isSaving: state.view.loadingModules.enrollingStudent 

   }))

   const handleInputChange = (event) => {
    setFormData({ ...formData, [event.target.name]: event.target.value}  )
  }

  
  // load options using API call
  const getTeachers = (srchQry) => {
    if (inputValue.length >= 3 ) return courseApi.getTeachers ( token, srchQry ).then(res => res );
  };

  const handleSelectChange = value => {
    setValue(value);
  };


   // handle selection
 const handleChange = value => {
    setSelectedValue(value);
  }
  
  const addSchedule = ( token, courseID, courseSubjectID ) => {
    if (!formData || !formData.timeFrom || !formData.timeTo || !formData.weekDay ) {
      alert("Complete día y horas de comienzo y fin") ;
    } else {
      let data = {
        "week_day": formData.weekDay,
        "start_time": formData.timeFrom,
        "end_time": formData.timeTo
      } ;
      scheduleClasss( token, courseID, courseSubjectID, data );
      let sche = [ ...subject.schedule ];
      sche.push(data)
      setSubject ( {...subject,
        schedule: sche
      } );
    }
  }

  const confirmEnrollTeacher = ( courseSubjectID ) => {
    if (selectedValue) {
        let data = {
          "persona_id": selectedValue.persona_id ,
          "tenured": "0"
       }

        enrollTeacher( token, course.course_id, courseSubjectID, data ) ;
        
        data.last_name = selectedValue.last_name;
        data.name = selectedValue.name;
        
        let tea = [ ...subject.teachers ];
        tea.push(data)
        setSubject ( {...subject,
          teachers: tea
        } );
      }
  }

  const confirmUnScheduleClass = ( token, courseID, courseSubjectID, courseSubjectScheduleID ) => {
    setSubject ( {...subject,
                      schedule: [ ...subject.schedule.filter((sch) => sch.course_subject_schedule_id !== courseSubjectScheduleID )]
                    } );
    unScheduleClass(token, courseID, courseSubjectID, courseSubjectScheduleID) ; 
  }


  const confirmUnEnrollTeache = ( token, courseID, courseSubjectID, personaID ) => {
    setSubject ( {...subject,
                      teachers: [ ...subject.teachers.filter((tea) => tea.persona_id !== personaID )]
                    } );
    unEnrollTeacher(token, courseID, courseSubjectID, personaID) ; 
  }

   

        return (
          
        <>
        <Card>
                <CardHeader>
                  <Row>
                    <Col className="pr-1" md="12">
                      <h5 className="title">{subject.long_name} - {course.name} - {course.shift_name}</h5>
                    </Col>
                  </Row>
                </CardHeader>
                <CardBody>
                  <Row>
                  <Col md="6">
                  <Table className="table table-striped mb-0" >
                     <tbody>
                     
                    { subject.teachers.map( ( teacher, idx ) => { 
                      return (
                        <>
                          <tr>
                            <td className="img-row">
                              <div className="img-wrapper">
                                <img
                                  alt="..."
                                  className="img-raised"
                                  src={teacher.image?teacher.image:Const.DEFAULT_IMAGE_PROFILE['O']}
                                />
                              </div>
                            </td>
                            <td className="text-left">
                             {Utils.capitalize(teacher.last_name + ", " + teacher.name)} 
                             {teacher.tenured==='1'&&
                                <>
                                  <br />
                                  <small>Titular</small>                                  
                                </>
                              }
                            </td>
                            <td className="td-actions text-right">
                              <Link
                                onClick={() => { confirmUnEnrollTeache(token, course.course_id, subject.course_subject_id, teacher.persona_id) }}
                              >
                              <i className={Icons.REMOVE} />
                            </Link>
                            </td>
                          </tr>
                        </> 
                          )
                      } ) }
                      <tr>
                        <td colspan="2">
                        <AsyncSelect
                              cacheOptions
                              defaultOptions
                              value={selectedValue}
                              getOptionLabel={e => Utils.capitalize( e.last_name + ", " + e.name ) }
                              getOptionValue={e => e.persona_id}
                              loadOptions={getTeachers}
                              onInputChange={handleSelectChange}
                              onChange={handleChange}
                              placeholder="Ingrese apellido ... "
                              noOptionsMessage={e => { return (<> No se encontro  <b>{inputValue}</b> </>) } }
                              loadingMessage={e => { if (inputValue.length >= 3 )
                                                        return "Buscando ... "
                                                        else return "ingrese al menos 3 letras del apellido para buscar"
                                                    }
                                              }
                            />
                        </td>
                        <td>
                          <Button color="success" size="sm"
                                  onClick={() => confirmEnrollTeacher( subject.course_subject_id )}
                                  >
                                <>
                                  <span className="btn-label">
                                    <i className="fa fa-floppy-o" aria-hidden="true"></i>
                                  </span>
                                  Agregar
                                </>
                                
                                </Button>
                        </td>
                      </tr>
                      </tbody>

                  </Table>
                  </Col>

                  <Col md="6">
                  <Table className="table table-striped mb-0" >
                     <tbody>
                     
                    { subject.schedule.map( ( sch, idx ) => { 
                      return (
                        <>
                          <tr>
                            <td className="text-left">
                              { Const.WEEK_DAYS_SHORT[sch.week_day-1] + " de " + sch.start_time.slice(0,5) 
                                    + " a " + sch.end_time.slice(0,5) }
                            </td>
                            <td className="td-actions text-right">
                              {sch.course_subject_schedule_id &&
                                  <Link
                                    onClick={() => { confirmUnScheduleClass(token, course.course_id, sch.course_subject_id, sch.course_subject_schedule_id) }}
                                  >
                                  <i className={Icons.REMOVE} />
                                </Link>
                              }
                            </td>
                          </tr>

                        </> 
                          )
                      } ) }
                      <tr>
                        <td colspan="2">
                        <Form>
                          <Row>
                            <Col>Agregar nuevo horario</Col>
                          </Row>
                          <Row>
                            <Col md="6">
                                <FormGroup>
                                      <Input
                                        name="timeFrom"
                                        type="time"
                                        id="exampleTime"
                                        placeholder="time placeholder"
                                        onChange={handleInputChange}
                                      />
                                </FormGroup>
                              </Col>
                              <Col md="6">
                                <FormGroup>
                                    <Input
                                      name="timeTo"
                                      type="time"
                                      id="exampleTime"
                                      placeholder="time placeholder"
                                      onChange={handleInputChange}
                                    />
                                </FormGroup>
                              </Col>
                          </Row>
                          <Row>
                            <Col md="6">
                                  <Select
                                    className="react-select" //  primary"
                                    classNamePrefix="react-select"
                                    name="weekDay"
                                    onChange={(sel) =>  setFormData({ ...formData, 'weekDay': sel.value }  )  }
                                    options={Const.WEEK_DAYS_MATRIX}
                                    placeholder="Día"
                                    
                                  />
                            </Col>
                            
                            <Col md="6">
                            <Button color="success" size="sm"
                                  onClick={() => addSchedule( token, course.course_id, subject.course_subject_id )}
                                  >
                                <>
                                  <span className="btn-label">
                                    <i className="fa fa-floppy-o" aria-hidden="true"></i>
                                  </span>
                                  Agregar
                                </>
                                
                                </Button>
                                
                            </Col>
                          </Row>
                        </Form>
                        </td>
                      </tr>

                      </tbody>

                  </Table>
                  </Col>


                  </Row> 
                </CardBody>
              </Card>
              </>
          );
    }

    // 